export const SCREEN_EDGE_MARGIN = 16;
export const TIP_EDGE_MARGIN = 2;
export const DEFAULT_TIP_SIZE = 12;
